import { createMachine } from "xstate";
import { commitOrder } from "@nju/data-access-portal-order";
import { cancelChangeSimEsim } from "@nju/data-access-portal-sim-card";

interface IContext {
  orchestratorId: string;
}

type IEvent =
  | { type: "ERROR" }
  | { type: "SUBMIT" }
  | { type: "SUCCESS" }
  | { type: "COMMIT_ORDER" }
  | { type: "CANCEL_ORDER"; buttonType: "BUTTON" | "BACK_BUTTON" }
  | { type: "COMMIT_ORDER_SUCCESS" }
  | { type: "CANCEL_ORDER_SUCCESS"; buttonType: "BUTTON" | "BACK_BUTTON" }
  | { type: "PESEL_REGISTERED_ERROR" }
  | { type: "PESEL_VERIFICATION_ERROR" };

export const changeSimSummaryMachine = createMachine(
  {
    schema: {
      context: {} as IContext,
      events: {} as IEvent,
    },
    initial: "manageOrder",
    states: {
      manageOrder: {
        on: {
          COMMIT_ORDER: {
            target: "commitOrder",
          },
          CANCEL_ORDER: {
            target: "cancelOrder",
          },
        },
      },
      commitOrder: {
        invoke: {
          src: "commitOrder",
        },
        on: {
          COMMIT_ORDER_SUCCESS: {
            actions: "onCommitOrderSuccess",
            target: "success",
          },
          PESEL_VERIFICATION_ERROR: {
            target: "onPeselVerificationError",
          },
          PESEL_REGISTERED_ERROR: {
            target: "onPeselRegisteredError",
          },
          ERROR: {
            target: "error",
          },
        },
      },
      cancelOrder: {
        invoke: {
          src: "cancelOrder",
        },
        on: {
          CANCEL_ORDER_SUCCESS: {
            actions: "onCancelOrderSuccess",
          },
          ERROR: {
            target: "error",
          },
        },
      },
      onPeselRegisteredError: {
        type: "final",
      },
      onPeselVerificationError: {
        type: "final",
      },
      error: {
        type: "final",
      },
      success: {
        type: "final",
      },
    },
  },
  {
    services: {
      commitOrder: ({ orchestratorId }) => {
        return async (callback) => {
          const result = await commitOrder({
            mode: "changeSimEsim",
            consent: [],
            orchestratorId,
          });

          if (result.isError) {
            if (result.err.code === "PESEL_NEGATIVE") {
              return callback({ type: "PESEL_VERIFICATION_ERROR" });
            }

            if (result.err.code === "PESEL_GOV_UNAVAILABLE") {
              return callback({ type: "PESEL_REGISTERED_ERROR" });
            }

            return callback({ type: "ERROR" });
          }

          return callback({ type: "COMMIT_ORDER_SUCCESS" });
        };
      },
      cancelOrder: ({ orchestratorId }, event) => {
        return async (callback) => {
          const result = await cancelChangeSimEsim({
            reason: "userRequest",
            orchestratorId,
          });

          if (result.isError) {
            return callback({ type: "ERROR" });
          }

          if (event.type === "CANCEL_ORDER") {
            return callback({
              type: "CANCEL_ORDER_SUCCESS",
              buttonType: event.buttonType,
            });
          }
        };
      },
    },
  },
);
